import React from 'react';
import { Route } from 'react-router-dom';

import AdminUsers from 'components/Admin/UsersList/AdminUsers';

export default function AdminRoutes() {
  return (
    <>
      <Route path={`/admin/users`} component={AdminUsers} />
    </>
  );
}



// WEBPACK FOOTER //
// ./src/routes/AdminRoutes.jsx